module.exports = {
      id: "fb-blue-usage",
      viewBox: "0 0 28 27.83",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#fb-blue",
      toString: function () {
        return this.url;
      }
    }